import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class InconsistenciesCiService {
	private readonly http: HttpClient;
	private readonly AuthLoginService: AuthLoginService;

	private headers: HttpHeaders;

	private readonly toggleInconsistencyCiMarkAsSolvedUrl = environment.baseApiUrl + 'inconsistency/{id}/ci/{idCi}/toggleMarkAsSolved';

	constructor(http: HttpClient, authLoginService: AuthLoginService) {
		this.http = http;
		this.AuthLoginService = authLoginService;
		this.headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	toggleInconsistencyCiMarkAsSolved(idInconsistency: string, idCi: string): Observable<any> {
		const url = this.toggleInconsistencyCiMarkAsSolvedUrl
			.replace('{id}', idInconsistency.toString())
			.replace('{idCi}', idCi.toString());
		return this.http.patch(url, {}, { headers: this.headers });
	}
}
